/// react
import { useState, useEffect } from "react";
// common
import PageLayout from "../../common/shell/PageLayout";
import TaskLayout from "../../common/shell/TaskLayout";
// me
import { IRootViewModel, RootViewModel } from "./models/models";
import * as actions from "./actions";
import ListView from "./views/ListView";

export default function Controller() {
    // initial state
    const [vm, setVm] = useState<IRootViewModel>(new RootViewModel());

    // on mount
    useEffect(() => {
        actions.initialise(setVm);
    }, []);

    return (
        <PageLayout title={["The Register of Identified Greenhouse Gas Storage Formations"]}>
            <TaskLayout isBusy={vm.isBusy} error={vm.error}>
                <ListView storageFormations={vm.storageFormations} />
            </TaskLayout>
        </PageLayout>
    );
}
